"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformToJSON = exports.PlatformFromJSONTyped = exports.PlatformFromJSON = exports.Platform = void 0;
/**
 *
 * @export
 */
exports.Platform = {
    Android: 'ANDROID',
    Car: 'CAR',
    Connect: 'CONNECT',
    Desktop: 'DESKTOP',
    Ios: 'IOS',
    Web: 'WEB'
};
function PlatformFromJSON(json) {
    return PlatformFromJSONTyped(json, false);
}
exports.PlatformFromJSON = PlatformFromJSON;
function PlatformFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PlatformFromJSONTyped = PlatformFromJSONTyped;
function PlatformToJSON(value) {
    return value;
}
exports.PlatformToJSON = PlatformToJSON;
